<template>
  <form @submit.prevent.stop="submit()">
    <div class="columns is-multiline is-margin-top-small">
      <div class="column is-12 is-paddingless">
        <div class="columns">
          <div class="column is-6 is-paddingless-top">
            <div class="field">
              <div class="control">
                <v-input id="code" name="code" @input="val => access.code = val" :model="access.login"
                        label="Login *"
                        v-validate="'required|min:4'" :errors-bag="errors" data-vv-value-path="val"
                        data-vv-as="Login">
                </v-input>
              </div>
            </div>
          </div>
          <div class="column is-6 is-paddingless-top">
            <div class="field">
              <div class="control">
                <v-input id="password" name="password" @input="val => access.password = val" :model="access.password"
                        label="Mot de passe *"
                        v-validate="'required|min:4'" :errors-bag="errors" data-vv-value-path="val"
                        data-vv-as="Mot de passe">
                </v-input>
              </div>
            </div>
          </div>
        </div>
        <div class="columns">
          <div class="column is-6 is-paddingless-top">
            <h3 class="title is-3">Niveau d'accès
              <span style="position: relative;" v-helper.bottom="'3BB7XF1V60WYgwOuI6S66O'">
                <i class="fal fa-question-circle has-text-grey is-size-6 is-margin-left-xsmall"></i>
              </span>
            </h3>
            <input class="is-checkradio" id="GLOBAL" value="GLOBAL" type="radio" name="GLOBAL"
                  v-model="access.scope">
            <label for="GLOBAL" class="label">Global</label>

            <input class="is-checkradio" id="PROGRAM" value="PROGRAM" type="radio" name="PROGRAM"
                  v-model="access.scope">
            <label for="PROGRAM" class="label">Programe</label>
          </div>
        </div>

        <div class="columns" v-if="access.scope && access.scope === 'PROGRAM'">
          <div class="column is-6 is-paddingless-top">
            <div class="field">
              <label class="label">PROGRAMME</label>
              <div v-if="programs">
                <multiselect v-model="access.program" :options="programs" :multiple="false" :searchable="true"
                            value="pk" :placeholder="''"
                            class="multiselect--option-ico"
                            :close-on-select="true" :show-labels="false"
                            label="name" track-by="pk" @search-change="getPrograms">
                  <span slot="placeholder" class="multiselect__placeholder">Sélectionnez ou saisissez un programme</span>
                  <span slot="noOptions">La liste est vide</span>
                </multiselect>
              </div>
            </div>
          </div>
        </div>
        <div class="columns">
          <div class="column is-6 is-paddingless-top">
            <label class="label">Début</label>
            <div class="field has-addons">
              <div class="control">
                <a class="button is-square is-static is-border is-min-width-0">
                  <span class="icon"><i class="fas fa-calendar-alt"></i></span>
                </a>
              </div>
              <div class="control is-expanded has-icons-right">
                <flat-pickr :config="configDate" v-model="startDate" class="input is-radiusless" name="startDate"></flat-pickr>
              </div>
              <div class="control">
                <a class="button is-grey is-inverted is-border is-square" @click="startDate = null">
                  <i class="fal fa-times"></i>
                </a>
              </div>
            </div>
          </div>
          <div class="column is-6 is-paddingless-top">
            <label class="label">Fin</label>
            <div class="field has-addons">
              <div class="control">
                <a class="button is-square is-static is-border is-min-width-0">
                  <span class="icon"><i class="fas fa-calendar-alt"></i></span>
                </a>
              </div>
              <div class="control is-expanded has-icons-right">
                <flat-pickr :config="configDate" v-model="endDate" class="input is-radiusless" name="endDate"></flat-pickr>
              </div>
              <div class="control">
                <a class="button is-grey is-inverted is-border is-square" @click="endDate = null">
                  <i class="fal fa-times"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="column is-12 is-paddingless is-border-top columns">
        <div class="column is-6">
          <a @click="$router.goBack(route)" class="button has-bg-white is-uppercase is-fullwidth">
            <span>Annuler</span>
          </a>
        </div>
        <div class="column is-6">
          <button class="button is-success is-uppercase is-fullwidth has-text-white" type="submit"
                  :disabled="!canSubmit || loading" :class="{'is-loading':loading}">
            <span v-if="!loading">Valider</span>
          </button>
        </div>
      </div>
    </div>
  </form>
</template>

<script>
  import moment from 'moment'

  const emptyAccess = {
    code: null,
    password: null,
    program: null,
    scope: null,
    start_date: null,
    end_date: null
  }

  export default {
    name: 'ExternAccessform',
    props: {
      loading: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {
        access: {},
        startDate: null,
        endDate: null,
        configDate: {
          altFormat: 'j/m/Y',
          altInput: true,
          dateFormat: 'd/m/Y'
        },
        programs: [],
        scopes: ['GLOBAL', 'PROGRAM'],
        route: this.$route
      }
    },
    computed: {
      a () {
        return this.access
      },
      datesAreValid () {
        if (this.startDate && this.endDate) {
          let startDate = moment(this.startDate, 'DD/MM/YY')
          let endDate = moment(this.endDate, 'DD/MM/YY')
          return startDate.isBefore(endDate)
        } else {
          return true
        }
      },
      canSubmit () {
        return this.datesAreValid && ((this.access.scope === 'PROGRAM' && this.access.program) || this.access.scope === 'GLOBAL')
      }
    },
    methods: {
      getPrograms (query) {
        this.$api.programService.get({name: query}).then(r => {
          this.programs = r.data.items
        })
      },
      submit () {
        if (this.startDate && this.endDate) {
          this.access.start_date = this.startDate
          this.access.end_date = this.endDate
        }
        this.$validator.validateAll()
          .then(isValid => {
            if (isValid) {
              this.access.login = this.access.code
              this.$emit('submit', this.access)
            } else {
              this.$emit('failed', this.access)
              this.$notify({
                type: 'is-danger',
                text: 'Oups ! Le Formulaire ne semble pas valide.'
              })
            }
          })
          .catch(() => {
            this.$emit('failed', this.access)
          })
      }
    },
    created () {
      this.getPrograms()
      this.access = Object.assign({}, emptyAccess)
    }
  }
</script>

<style>


</style>



// WEBPACK FOOTER //
// src/components/external-access/ExternalAccessForm.vue